import template from './loansDetailRequestIt.html';
import controller from './loansDetailRequestIt.controller';
import './loansDetailRequestIt.scss';

let loansDetailRequestItComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default loansDetailRequestItComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailRequestIt/loansDetailRequestIt.component.js